
import { Component, Vue } from 'vue-property-decorator';


@Component
export default class FillForm7SoughtInfo extends Vue {
   

}
